var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldPersonFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.751 11.995a2.25 2.25 0 012.248 2.25v.918a2.75 2.75 0 01-.512 1.598c-1.546 2.164-4.07 3.235-7.49 3.235-3.422 0-5.945-1.072-7.487-3.236A2.75 2.75 0 010 15.164v-.92a2.25 2.25 0 012.249-2.249h11.502zM7.996 0a5 5 0 110 10 5 5 0 010-10z",
    fill: "#333230"
  })));
}
export default SvgPldPersonFilled;